<template>
  <div
    class="container"
    @click="register"
    >
    <div class="button">
      {{ $l.clickAlreadyRegistered }}
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  methods: {
    register: function () {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
}

.button {
  box-sizing: border-box;
  color: white;
  padding-bottom: 3px;
  &:hover {
    cursor: pointer;
    border-bottom: 1px solid white;
  }
}
</style>
